import { render, staticRenderFns } from "./alignMiddle_on.vue?vue&type=template&id=d5cd7d04&"
import script from "./alignMiddle_on.vue?vue&type=script&lang=ts&"
export * from "./alignMiddle_on.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports